<div class="custom-dialog">
  <div class="custom-dialog__picture">
    <img
      src="/shared/svg/verified-image.svg"
      height="157"
      alt="KYC Verification Required"
    />
  </div>

  <div class="custom-dialog__content">
    <h2 class="custom-dialog__content__title mat-headline-small">
      We need to verify your identity
    </h2>
    <p class="custom-dialog__content__subtitle">
      This quick process helps us protect you and ensure a safe gaming
      experience.
    </p>
  </div>

  <div class="custom-dialog__actions">
    <a
      mat-flat-button
      color="primary"
      class="fz-button--medium mdc-button mdc-button--unelevated mat-mdc-unelevated-button"
      [attr.href]="data.url"
    >
      Verify now
    </a>
  </div>
</div>
